import React from 'react';

interface TreeItemLabelProps {
  text: string;
  /** Optional icon element displayed before the text */
  statusIcon?: React.ReactNode;
  /** Optional secondary text displayed under the main label */
  subText?: string;
  /** Optional search term to highlight in the text */
  searchTerm?: string;
  /** Optional test case count to display before subText */
  testCaseCount?: number;
  /** Optional project count for folder items */
  projectCount?: number;
  /** Optional ID to show in tooltip */
  id?: number | string;
}

const TreeItemLabel: React.FC<TreeItemLabelProps> = ({
  text,
  statusIcon,
  subText,
  searchTerm,
  testCaseCount,
  projectCount,
  id,
}) => {
  // Helper function to highlight search text
  const highlightSearchText = (text: string, searchTerm?: string) => {
    if (!searchTerm || !text) return text;
    
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? 
        <span key={index} style={{ backgroundColor: '#ffeb3b', fontWeight: 'bold', padding: '1px 2px', borderRadius: '2px' }}>{part}</span> : 
        part
    );
  };

  return (
    <div
      className="tree-item-label"
      title={id ? `${id}: ${text}` : text}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', position: 'relative', gap: 0 }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {statusIcon}
        <span
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block', // Required for text-overflow to work on a span
          }}
        >
          {highlightSearchText(text, searchTerm)}
        </span>
      </span>
      {(subText || testCaseCount !== undefined /* || projectCount !== undefined */) && (
        <span style={{ fontSize: '0.7rem', color: '#666', lineHeight: 1 }}>
          {/* {projectCount !== undefined && `${projectCount} Project${projectCount === 1 ? '' : 's'}`} */}
          {/* {projectCount !== undefined && testCaseCount !== undefined && ' • '} */}
          {testCaseCount !== undefined && `${testCaseCount} Test Case${testCaseCount === 1 ? '' : 's'}`}
          {/* {(projectCount !== undefined || testCaseCount !== undefined) && subText && ' • '} */}
          {testCaseCount !== undefined && subText && ' • '}
          {subText && highlightSearchText(subText, searchTerm)}
        </span>
      )}
    </div>
  );
};

export default TreeItemLabel;
